import { useTranslation } from 'react-i18next'

import AlertNotification from '@/common/components/AlertNotification/AlertNotification'

import SubStatusMessage from './SubStatusMessage/SubStatusMessage'
import { findException, getAlertActions, getDateByStatus } from './helpers'

const ParcelAlert = ({
  alert,
  parcelStatus,
  createdAt,
  packedAt,
  readyAt,
  shippedAt,
  outForDeliveryAt,
  deliveredAt,
  normalizedTrackingStatus,
  onGenerateLabel,
  generatingLabel,
  openEditOutboundDestinationAddressModal,
  openSendEmailModalForContactCustomer,
  openSendEmailModalForContactCarrier,
  markParcelAlertAsRead,
  openEditCustomsModal,
}) => {
  const { t } = useTranslation()

  const exception = findException(alert)

  if (!exception) return null

  const statusTime = getDateByStatus({
    status: parcelStatus,
    createdAt,
    packedAt,
    readyAt,
    shippedAt,
    outForDeliveryAt,
    deliveredAt,
  })

  const actions = getAlertActions({
    exception,
    t,
    onGenerateLabel,
    generatingLabel,
    openEditOutboundDestinationAddressModal,
    openSendEmailModalForContactCustomer,
    openSendEmailModalForContactCarrier,
    markParcelAlertAsRead,
    openEditCustomsModal,
  })

  const extraInfo = (
    <SubStatusMessage
      parcelStatus={parcelStatus}
      normalizedTrackingStatus={normalizedTrackingStatus}
      exception={alert}
      statusTime={statusTime}
    />
  )

  return (
    <AlertNotification
      title={t(exception.title)}
      createdAt={alert?.created_at}
      actions={actions}
      extraInfo={extraInfo}
    />
  )
}

export default ParcelAlert
